require('./cardsCreditBalanceBar.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classnames = require('classnames');

// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @utilities
const { getCardAvailableBalance } = require('utilities/cardsHelper');

// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const ComparativeBar = require('components/commons/comparativeBar/comparativeBar');
const { LoadingDots } = require('commonsComponents/loadingDots');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @ constants
const { CARD_CREDIT } = require('constants/index');
const language = getLanguage();

class CardsCreditBalanceBar extends React.Component {
    getBalance() {
        const { immCard, loading } = this.props;
        const cardAvailableBalance = getCardAvailableBalance(immCard);
        const plainAmountObject = cardAvailableBalance && getPlainAmountObject(cardAvailableBalance);

        if (loading) {
            return (
                <span className="cards-credit-balance-bar__available-amount">
                    <LoadingDots inline color="light" size="medium" />
                </span>
            );
        }

        if (!cardAvailableBalance)
            return null

        return (
            <OneLineSymbolAmount
                className="cards-credit-balance-bar__available-amount"
                amountObject={plainAmountObject}
                language={language}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
            />
        );
    }

    render() {
        const { immCard, showTooltip } = this.props;
        const cardType = immCard.get('type');
        const isCancelled = immCard.get('cancelled');
        const availableAmount = immCard.getIn(['availableBalance', 'amount'])
        const balanceDrawn = immCard.getIn(['balanceDrawn', 'amount'])
        const plainAmountBalanceObject = immCard.get('balanceDrawn') && getPlainAmountObject(immCard.get('balanceDrawn'));
        const plainAmountObject = immCard.get('limit') && getPlainAmountObject(immCard.get('limit'));
        const classNames = classnames('cards-credit-balance-bar', {
            'cards-credit-balance-bar--disabled': isCancelled
        });

        let balanceDrawnForBar;
        if (isCancelled) {
            balanceDrawnForBar = 0;
        } else {
            balanceDrawnForBar = balanceDrawn;
        }

        let drawContent;
        let barContent;
        let limitContent;
        let availableBullet;
        let drawBullet;
        let cardTooltip;

        if (cardType === CARD_CREDIT) {
            if (!isCancelled) {
                drawBullet = <span className="cards-credit-balance-bar__draw-bullet" />;
                availableBullet = <span className="cards-credit-balance-bar__available-bullet" />;
            }

            if (showTooltip) {
                cardTooltip = (
                    <OKTooltip
                        content="cards-cardPayLaterTooltip"
                        modifier="dark-bg"
                        offset={[-15, 0]}
                        placement="left"
                    />
                );
            }

            drawContent = !!plainAmountBalanceObject && (
                <div className="cards-credit-balance-bar__draw">
                    {drawBullet}
                    <FormattedText value="cards-drawnBalance" />
                    <OneLineSymbolAmount
                        amountObject={plainAmountBalanceObject}
                        className="cards-credit-balance-bar__draw-amount"
                        positiveAmount={true}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountBalanceObject, true)}
                    />
                    {cardTooltip}
                </div>
            );

            barContent = balanceDrawnForBar != null && balanceDrawn != null && availableAmount != null && (
                <ComparativeBar
                    firstValue={balanceDrawnForBar}
                    totalValue={balanceDrawn + availableAmount}
                    firstValueText={formatText('cards-balanceDrawnTooltipText')}
                    secondValueText={formatText('cards-availableBalanceTooltipText')}
                    className="cards-credit-balance-bar__bar"
                />
            );

            limitContent = !!plainAmountObject && (
                <div className="cards-credit-balance-bar__limit">
                    <FormattedText value="cards-limit" />
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        className="cards-credit-balance-bar__limit-amount"
                        trimDecimals
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                    />
                </div>
            );
        }

        let availableKey;
        if (cardType === CARD_CREDIT) {
            availableKey = 'cards-available';
        } else {
            availableKey = 'cards-balance';
        }

        let balance = this.getBalance();

        return (
            <div className={classNames}>
                {limitContent}
                {barContent}
                <div className="cards-credit-balance-bar__top-wrapper">
                    {drawContent}
                    <div className="cards-credit-balance-bar__available">
                        {availableBullet}
                        <FormattedText value={availableKey} />
                        {balance}
                    </div>
                </div>
            </div>
        );
    }
}

CardsCreditBalanceBar.propTypes = {
    loading: PropTypes.bool,
    immCard: PropTypes.object.isRequired,
    showTooltip: PropTypes.bool
};

CardsCreditBalanceBar.DefaultProps = {
    loading: false,
    showTooltip: false
};

module.exports = CardsCreditBalanceBar;
